// Copyright (c) 2019 First Foundry Inc. All rights reserved.

import { graphql } from 'api/operationCompat'
import { getPackageChangeLog } from 'ops'
import { get } from 'lodash'
import { DEFAULT_TIMEZONE } from 'constants/Settings'
import moment from 'moment-timezone'

const withPackageLogs =
  graphql(getPackageChangeLog, {
    name: 'packageChangeLogData',
    options: ({
      match,
      startDate,
      endDate,
      venueSettings,
    }) => {
      const storeTimezone = get(venueSettings, 'store.timezone', DEFAULT_TIMEZONE)
      return ({
        variables: {
          packageId: match.params.id,
          filter: { // Query store time in UTC
            startDt: moment.tz(startDate, storeTimezone).startOf('day').utc().toISOString(),
            endDt: moment.tz(endDate, storeTimezone).endOf('day').utc().toISOString(),
          },
        },
      })
    },
    skip: ({ selectedVenueId }) => !selectedVenueId,
  })

export default withPackageLogs
